import { lazy } from "react";
import routes from "./routesConfig/index";


const JobOfferPage = lazy(() => import("../JobOfferPage/JobOfferPage"));
const jobOffersDuplicates = lazy(() => import("../JobOfferPage/JobOfferDuplicates"));

const jobRoutes = [
  { path: routes.jobOffers, component: JobOfferPage, permissionKey: "jo_access", moduleKey: "jo" },
  { path: routes.jobOffersDuplicate, component: jobOffersDuplicates, permissionKey: "jo_access", moduleKey: "jo" },
];

export default jobRoutes;
